


































import {Component, Prop, Vue} from 'vue-property-decorator'
import BtnDefault from "@/components/UI/BtnDefault.vue";
import Router from "@/router";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";

@Component({
  name: 'StandsProductsScanned',
  components: {ErrorFetchingData, BtnDefault}
})

export default class StandsProductsScanned extends Vue {
  @Prop({ type: Boolean, default: false}) protected loading!: boolean
  @Prop({ type: Boolean, default: false}) protected error!: boolean
  @Prop({ type: Object, default: () => {}}) protected products!: any

  get productsCount() {
    if (this.products.products) return this.products.products.length
    else return null
  }
  get hasScannedProducts() {
    if (!this.products.products.length) return false
    return this.products.products.some((prod: any) => prod.value)
  }
  get firstTwoProducts() {
    return this.products.products.slice(0, 2)
  }

  toProducts() {
    Router.push({ path: 'products' })
  }
}
